import React, { useEffect, useState } from 'react';
import { Text } from '../../components/base/Text';
import { ListItems } from '../../components/base/ListItems';
import { isNonEmpty } from '../../utils/arrayUtils';
import Loading from '../../components/base/Loading';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useGetFlowLogs } from '../../networking/useFlowLogs';
import { ReloadOutlined } from '@ant-design/icons';
import { useGetFlows } from '../../networking/useFlow';
import { SenderEnum } from '../../components/chat';
import { ChatView } from '../../components/chat/ChatView';
export const AssistantLogs = () => {
    const [flows, setFlows] = useState([]);
    const [logs, setLogs] = useState([]);
    const [selectedFlow, setSelectedFlow] = useState(null);
    const { isLoading: isLoadingGetFlows, call: callGetFlows, data: flowsResponse } = useGetFlows({});
    const { isLoading, call: callGetFlowLogs, data: logsResponse } = useGetFlowLogs();
    const [flowListItems, setFlowListItems] = useState([]);
    useEffect(() => {
        const flowListItems = [];
        for (let flow of flows) {
            flowListItems.push({
                header: flow.name,
                subheader: flow.description,
                loading: false,
                onClick: () => {
                    setSelectedFlow(flow);
                },
            });
        }
        setFlowListItems(flowListItems);
    }, [flows]);
    useEffect(() => {
        if (flowsResponse && isNonEmpty(flowsResponse.items)) {
            setFlows(flowsResponse.items);
            setSelectedFlow(flowsResponse.items[0]);
        }
    }, [flowsResponse]);
    useEffect(() => {
        if (!isLoading && logsResponse && isNonEmpty(logsResponse.items)) {
            if (logs.length !== logsResponse.items.length) {
                setLogs(logsResponse.items);
            }
        }
    }, [logsResponse]);
    useEffect(() => {
        if (!selectedFlow)
            return;
        const fetchLogs = async () => {
            callGetFlowLogs({ flowId: selectedFlow?.id });
        };
        fetchLogs();
        const interval = setInterval(fetchLogs, 10000);
        return () => clearInterval(interval);
    }, [selectedFlow]);
    useEffect(() => {
        callGetFlows();
    }, []);
    const getMessages = (logs) => {
        return logs.map((log) => {
            return {
                messageId: log.id,
                text: log.message.content,
                sender: SenderEnum[log.message.role],
                showMessageMetadata: ['sender', 'timestamp', 'agent_name'],
                timestamp: log.created_utc,
                agent_name: log.message.agent_name,
            };
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex', minHeight: '70vh', maxHeight: '75vh' } },
            React.createElement("div", { style: { flex: 1, padding: '1rem' } },
                React.createElement("div", { className: "flex-row", style: { justifyContent: 'space-between' } },
                    React.createElement(Text, { value: 'Flows', className: "header2" }),
                    React.createElement(ReloadOutlined, { onClick: () => {
                            callGetFlows();
                        } })),
                isLoadingGetFlows ? (React.createElement(Loading, { absolute: false })) : isNonEmpty(flowListItems) ? (React.createElement(ListItems, { items: flowListItems, itemLayout: "horizontal" })) : (React.createElement(Text, { value: "No flows found" }))),
            selectedFlow ? (React.createElement("div", { style: {
                    flex: 2,
                    transition: 'transform 0.4s ease-in-out',
                    transform: selectedFlow ? 'translateX(0)' : 'translateX(100%)',
                    backgroundColor: 'white',
                    padding: '1rem',
                    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                    borderRadius: 8,
                    width: '60%',
                } }, isNonEmpty(logs) ? (React.createElement(React.Fragment, null,
                React.createElement(ChatView, { title: 'Flow Chat', messages: getMessages(logs), chatRecommendations: [], style: {
                        backgroundColor: 'white',
                    }, handleSubmit: async () => {
                        console.log('CLicks');
                    }, disabled: true }))) : (React.createElement(Text, { value: "Agents logs will appear here" })))) : null)));
};
export default withAuthenticationRequired(AssistantLogs, {
    onRedirecting: () => React.createElement(Loading, null),
});
